import React from 'react';
import PropTypes from 'prop-types';
import ReadpointService from "../../services/ReadpointService";
import Loading from "../../component/Loading/Loading";
import Notify from "../../services/Notify";
import {Col, ListGroup, ListGroupItem, Row} from "react-bootstrap";

class ReadpointCustomSelect extends React.Component {

  service = new ReadpointService();

  constructor(props) {
    super(props);
    this.addOrRemoveReadPoint = this.addOrRemoveReadPoint.bind(this);
    this.state = {ids: props.readpointsIds || [], loading: true};
    props.setValue && props.setValue(this.state.ids);
  }

  componentDidMount() {
    this.setState({loading: true});
    this.service.findAll(0, 100).then(
        data => this.setState(
            {
              loading: false,
              readpoints: data.content
            }),
        error => {
          const state = {loading: false};
          console.log('here : ' + error.response);
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  addOrRemoveReadPoint(id) {
    const {setValue} = this.props;
    const position = this.state.ids.indexOf(id);
    if (position >= 0) {
      this.state.ids.splice(position, 1);
    } else {
      this.state.ids.push(id);
    }
    setValue && setValue(this.state.ids);
    this.setState({ids: this.state.ids});
  }

  render() {
    let {readpoints = [], loading} = this.state;

    if (loading) {
      return <Loading/>
    }

    return (
        <Row>
          <Col lg={6} sm={6}>
            <ListGroup>
              {readpoints.map(({id, friendlyName}) => {
                    const active = (this.state.ids || []).indexOf(id) >= 0 ? 'active' : '';
                    return (
                        <ListGroupItem href="#" onClick={(e) => {
                          e.preventDefault();
                          this.addOrRemoveReadPoint(id);
                        }} key={id} active={active}>
                          <h5>{friendlyName}</h5>
                        </ListGroupItem>
                    )
                  }
              )}
            </ListGroup>
          </Col>
        </Row>
    );
  }
}

ReadpointCustomSelect.propTypes = {
  readpointsIds: PropTypes.array,
  history: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default ReadpointCustomSelect;



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointCustomSelect.js